export default __webpack_public_path__ + "static/media/logo.9d7c5df6.png";